export const PATH = {
  HOME: '/',

  TAX_CDS_INTRODUCE: '/tax-cds/introduce',
  TAX_CDS_SMART_ASSISTANT: '/tax-cds/smart-assistant',
  TAX_CDS_SMART_ASSISTANT_INFO: '/tax-cds/smart-assistant/info',
  
  AUTO_TRAFFIC_FINE_NOTIFICATION_LOOKUP: '/auto-traffic-fine-notification/lookup',
  AUTO_TRAFFIC_FINE_NOTIFICATION_CHECK_RESULT: '/auto-traffic-fine-notification/check-result',
  AUTO_TRAFFIC_FINE_NOTIFICATION_PACKAGE_INFO: '/auto-traffic-fine-notification/package-info',
  AUTO_TRAFFIC_FINE_NOTIFICATION_SERVICES: '/auto-traffic-fine-notification/services',
  AUTO_TRAFFIC_FINE_NOTIFICATION_VEHICLES: '/auto-traffic-fine-notification/vehicles',
  AUTO_TRAFFIC_FINE_NOTIFICATION_PAYMENT: '/auto-traffic-fine-notification/payment',
  AUTO_TRAFFIC_FINE_NOTIFICATION_INTRODUCE: '/auto-traffic-fine-notification/introduce',
  AUTO_TRAFFIC_FINE_NOTIFICATION_SUCCESS: '/auto-traffic-fine-notification/success/:id',
  AUTO_TRAFFIC_FINE_NOTIFICATION_PAYMENT_SUCCESS: '/auto-traffic-fine-notification/payment-success',
  AUTO_TRAFFIC_FINE_NOTIFICATION_REDIRECT_HANDLER: '/auto-traffic-fine-notification/redirect-handler',
  AUTO_TRAFFIC_FINE_NOTIFICATION_AUTHENTICATION: '/auto-traffic-fine-notification/authentication',
  AUTO_TRAFFIC_FINE_NOTIFICATION_PHONE_AUTH: '/auto-traffic-fine-notification/phone-auth',
  TRAFFIC_FINE_FAQ: '/traffic-fine-faq'
}

export const PATH_FAQ = '/traffic-fine-faq'
